import { useMemo } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useSetCurrentLanguage } from 'js/hooks/language';
import { languageService } from 'js/services/language.service';

export const useLanguagePublicAPI = () => {
    const currentLang = useUserSelector(prop('lang'));
    const setCurrentLanguage = useSetCurrentLanguage();

    return useMemo(() => ({
        /**
         * Retrieve current 5-symbols language, en_GB.
         * @memberOf Playtech.API.language
         * @function
         * @returns {string}
         * @example
         * // 'en_US'
         * Playtech.API.language.getCurrentLanguage();
         */
        getCurrentLanguage: () => currentLang,
        /**
         * Retrieve current 2-symbols language, en.
         * @memberOf Playtech.API.language
         * @function
         * @param {string} lang In 5-symbols format, en_GB, de_DE, ...
         * @returns {string}
         * @example
         * // 'en'
         * Playtech.API.language.getTwoLetterLanguage('en_US');
         */
        getTwoLetterLanguage: (lang) => languageService.getTwoLetterLanguage(lang),
        /**
         * Set language.
         * @memberOf Playtech.API.language
         * @param {string} langToSet In 5-symbols format, en_GB, de_DE, ...
         * @function
         * @example
         * Playtech.API.language.setCurrentLanguage('en_GB');
         */
        setCurrentLanguage
    }), [currentLang, setCurrentLanguage]);
};
